module.exports = __webpack_public_path__ + "static/img/pic_word_big.4a90d7ae.png";